var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"track",staticClass:"scrollbar__track",on:{"mousedown":_vm.handleTrackMousedown}},[_c('div',{ref:"thumb",staticClass:"scrollbar__thumb",on:{"mousedown":_vm.handleThumbMousedown}})])}
var staticRenderFns = []

export { render, staticRenderFns }